import router from './router'
import propertyTheftMessages from './localization'

export default {
  router,
  localization: propertyTheftMessages,
}
